export default __webpack_public_path__ + "static/media/note.bf573f80.svg";